import { Loading } from 'element-ui'
let loadingInstance = ''
export const startLoading = () => {
  loadingInstance = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
export const endLoading = () => {
  loadingInstance.close()
}



// WEBPACK FOOTER //
// ./src/pages/config/serviceLoading.js